const TIMEOUT_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds

let logoutTimer;

export const startLogoutTimer = (logoutCallback) => {
  if (logoutTimer) clearTimeout(logoutTimer);
  
  logoutTimer = setTimeout(() => {
    logoutCallback();
  }, TIMEOUT_DURATION);
};

export const resetLogoutTimer = (logoutCallback) => {
  startLogoutTimer(logoutCallback);
};

export const clearLogoutTimer = () => {
  if (logoutTimer) clearTimeout(logoutTimer);
};

// Keys that make up a client session. Cleared together on logout / 401 / a
// failed auth check so a tampered or half-cleared localStorage can't linger.
const SESSION_KEYS = ['token', 'userData'];

export const getToken = () => localStorage.getItem('token');

export const clearSession = () => {
  SESSION_KEYS.forEach((k) => localStorage.removeItem(k));
};

// Decode a JWT payload WITHOUT verifying (client can't verify — only the server
// can). Used purely to read `exp` so we don't render the admin shell behind an
// obviously-expired token. Real enforcement is server-side on every request.
const decodeJwtPayload = (token) => {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
};

// A token is usable if it exists, decodes, and its `exp` (seconds) is in the
// future. Missing/!exp tokens fail closed.
export const isTokenValid = () => {
  const token = getToken();
  if (!token) return false;
  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) return false;
  return payload.exp * 1000 > Date.now();
};